import SectionHeader from 'components/SectionHeader';
import {FC, ReactNode} from 'react';
import {twMerge} from 'tailwind-merge';

type DocumentGroupProps = FC<{
    children: ReactNode;
    className?: string;
    title: string;
}>;
const DocumentGroup: DocumentGroupProps = ({children, className, title}) => (
    <div
        className={twMerge(
            'p-4 bg-grey-50 border border-grey-400 rounded',
            className,
        )}
    >
        <SectionHeader className="mt-0" title={title} />
        {children}
    </div>
);

export default DocumentGroup;
